import { type FC } from "react";

import { Card } from "@snapchat/snap-design-system";

import emptySearchSvg from "@app-assets/svg/empty-search.svg";

import { AddFolderModal } from "../list/header/AddLensFolder";

import { CardContent, EmptySearchSvg, cardTitleCss } from "./NoLensFoldersCard.styles";
import {
    LensFolderNotFound,
    LensFolderNotFoundContent,
    NoLensFolders,
    NoLensFoldersContent,
} from "./messages.generated";

interface NoLensFoldersCardProps {
    fromSearch?: boolean;
}

export const NoLensFoldersCard: FC<NoLensFoldersCardProps> = ({ fromSearch }) => {
    return (
        <Card
            title={fromSearch ? <LensFolderNotFound /> : <NoLensFolders />}
            titleBorder={false}
            titleClassName={cardTitleCss}
            data-testid="no-lens-folders-card"
        >
            <CardContent>
                <EmptySearchSvg data-testid="empty-search-icon" alt="Empty search" src={emptySearchSvg} />
                {fromSearch ? (
                    <LensFolderNotFoundContent />
                ) : (
                    <>
                        <NoLensFoldersContent />
                        <AddFolderModal />
                    </>
                )}
            </CardContent>
        </Card>
    );
};
